import React, { useEffect, useState } from 'react'
import "./groupMain.css";
import { Link } from "react-router-dom";
import FotterGroup from "../Fotter/FotterGroup";
import axios from '../../axios';
import CreateMoreGroups from '../CreteMoreGroup/CreateMoreGroups';

function GroupMain() {
  const [click, setClick] = useState(false);
  const [click1, setClick1] = useState(false);
  const [grop, setGrop] = useState()
  const [add, setAdd] = useState();
  const [member, setMember] = useState(false);
  const [groups, setGroups] = useState([]);
  const handelClick1 = () => {
    setClick1(true);

  };
  let teacher_id = JSON.parse(localStorage.getItem("Teacher_id"));
  const [filter, setFilter] = useState({
    subjects: [],
    type: null,
    clicked: false,
  })

  const { clicked, subjects, type } = filter;
  const [done, setDone] = useState(false)

  useEffect(() => {
    const getGroups = async () => {
      try {
        let res = await axios.get(
          `api/v1/group/filterForTeacher/teacherId/${teacher_id}?_page=1&_limit=1`
        );
        res && setGroups(res.data.data);
        setDone(true);
      } catch (error) {
        console.log(error);
      }
    };
    getGroups();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [clicked]);
  return (
    <>
      {groups?.length > 0 ? <CreateMoreGroups /> : done && <div className="container_addgroup ">

        <div className="Group_create">
          <div>
            <h3 className="group_Title">Create Groups</h3>
            <p className=" group_subTitle ">
              You can create new groups for collective information sharing.
            </p>
            <Link to="/createGroups">
              <button  id='addPreReadBtn'>Create</button>
            </Link>
          </div>
        </div>

      </div>}
    </>

  );
}

export default GroupMain;
